/*
 * Copyright © 2022 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {
    Component, OnInit, Input, Output, EventEmitter
} from '@angular/core';

export interface IHeader {
    leftHeader: string,
    rightHeader: string
}

/**
 * Fc Double Select List.
 */
@Component({
    selector: 'fc-ag-double-list',
    templateUrl: './fc-ag-double-list.component.html',
    styleUrls: ['./fc-ag-double-list.component.scss']
})
export class FcAgDoubleListComponent implements OnInit {
    /**
     * Constructor.
     */
    constructor() {
    }

    /**
     * Available item list.
     */
    @Input() availableItemList: any[]= [];

    /**
     * Available item list.
     */
    @Input() selectedItemList: any[] = [];

    /**
     * Event emit double select list data changed.
     */
    @Output() selectedItemListChange: EventEmitter<any> = new EventEmitter();

    /**
     *
     */
    @Output() availableItemListChange: EventEmitter<any> = new EventEmitter();

    /**
     * Left header for double select list.
     */
    @Input() leftHeader?: string = 'Available';

    
    /**
     * Left header for double select list.
     */
    @Input() rightHeader?: string = 'Selected';

    /**
     * Initial circle.
     *
     */
    ngOnInit() {
        this.availableItemList = this.sortObjectArray(this.addIsSelectedField(this.availableItemList));
        this.selectedItemList = this.sortObjectArray(this.addIsSelectedField(this.selectedItemList));
    }

    /**
     * Toggle Selected.
     * 
     * @param item Selected item.
     */
    toggleSelected(item: any) : void {
        item.isSelected = !item.isSelected;
    }

    /**
     * Add Item From Available to Selected List.
     *
     */
    addItems() : void {
        this.availableItemList.forEach((item: any, index) => {
            if (item.isSelected) {
                let tempItem = {...item};
                tempItem.isSelected = !tempItem.isSelected;
                this.selectedItemList.push(tempItem);
            }
        });
        this.availableItemList = this.availableItemList.filter((item: any )=> !item.isSelected);
        this.sortObjectArray(this.selectedItemList);
        this.selectedItemListChange.emit(this.selectedItemList);
        this.availableItemListChange.emit(this.availableItemList);
    }

    /**
     * Remove Item From Selected to Available List.
     *
     */
    removeItems() : void {
        this.selectedItemList.forEach((item: any, index) => {
            if (item.isSelected) {
                let tempItem = {...item};
                tempItem.isSelected = !tempItem.isSelected;
                this.availableItemList.push(tempItem);
            }
        });
        this.selectedItemList = this.selectedItemList.filter((item: any )=> !item.isSelected);
        this.sortObjectArray(this.availableItemList);
        this.selectedItemListChange.emit(this.selectedItemList);
        this.availableItemListChange.emit(this.availableItemList);
    }

    /**
     * Add property 'isSelected'.
     * 
     * @param list List available/selected items.
     * @returns List with new selected status.
     */
    addIsSelectedField(list :any[]): any {
        for (var i = 0; i < list.length; i++) {
            list[i] = Object.assign(list[i], {
                isSelected: false
            });
        }
        return list;
    }

    /**
     * Sort Object Array.
     *
     * @param items List available/selected items.
     * @returns Sorted items.
     */
    sortObjectArray(items : any[]) : any {
        items.sort(function(a, b) {
            let nameA = a.label.toUpperCase();
            let nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        return items;
    }
}
